import React, { createContext, useContext, useState, useCallback } from 'react';
import labels from '../utils/labels';

const TONE_STORAGE_KEY = 'hisab_tone_enabled';

const ToneContext = createContext();

export const ToneProvider = ({ children }) => {
  const [toneEnabled, setToneEnabled] = useState(() => {
    return localStorage.getItem(TONE_STORAGE_KEY) === 'true';
  });

  const toggleTone = useCallback(() => {
    setToneEnabled(prev => {
      const next = !prev;
      localStorage.setItem(TONE_STORAGE_KEY, String(next));
      return next;
    });
  }, []);

  const setTone = useCallback((value) => {
    setToneEnabled(value);
    localStorage.setItem(TONE_STORAGE_KEY, String(value));
  }, []);

  const t = useCallback((key) => {
    const entry = labels[key];
    if (!entry) return key;
    return toneEnabled ? entry.on : entry.off;
  }, [toneEnabled]);

  return (
    <ToneContext.Provider value={{ toneEnabled, toggleTone, setTone, t }}>
      {children}
    </ToneContext.Provider>
  );
};

export const useTone = () => {
  const context = useContext(ToneContext);
  if (!context) {
    throw new Error('useTone must be used within a ToneProvider');
  }
  return context;
};

export default ToneContext;
